import React, { Component } from 'react';
import Jumbotron from './components/Jumbotron';
import About from './components/About';
import Prizes from './components/Prizes';
import Interviews from './components/Interviews';
import Judges from './components/Judges';
import Schedule from './components/Schedule';
import Notice from './components/Notice';
import Oakhouse from './components/Oakhouse';

class Home extends Component {
  render() {
    return (
      <div>
        <Jumbotron />
        <About />
        <Prizes />
        <Interviews />
        <Judges />
        <Schedule />
        <Notice />
        <Oakhouse />
      </div>
    );
  }
}

export default Home;
